import script from "./AllEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./AllEvent.vue?vue&type=script&setup=true&lang=js"

import "./AllEvent.vue?vue&type=style&index=0&id=145b72d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-145b72d0"]])

export default __exports__